import React, { useState } from "react";
import { Copy, Check } from "lucide-react";
import { List } from "components";
import CreateItemButton from "components/buttons/create";
import { EmployeeCell } from "components/cell/employee/cell";
import { getdirectusUserFields } from "components/user/config";
import CreateCaseStudyDialog from "./casestudy/crud/form/input";
import CaseStudiesFilters from "./filter";
import HeaderPortal from "components/portal/header-portal";
import { DateCell } from "components/cell/date/cell";
import { StatusCell } from "components/cell/status/cell";
import IndustryTypeText from "components/industry/display";
import { PermissionGate } from "permissions/components/gate";

export default function CaseStudiesIndex() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [copiedId, setCopiedId] = useState(null);

  const handleShare = (e, id) => {
    e.preventDefault();
    e.stopPropagation();
    const url = `${window.location.origin}/case-studies/${id}`;
    navigator.clipboard.writeText(url);
    setCopiedId(id);
    setTimeout(() => setCopiedId(null), 1500);
  };

  const fields = [
    "id",
    "name",
    "status",
    "industry",
    "nda_level",
    "project.name",
    "industry_v1.name",
    "industry_v1.type",
    "project_name_alias",
    getdirectusUserFields("user_created"),
    "date_created",
  ];
  const columns = [
    {
      id: "name",
      header: "Name",
      accessorKey: "name",
      cell: ({ row }) => {
        return (
          <span className="capitalize">
            {row.original?.name?.replace(/_/g, " ")}
          </span>
        );
      },
    },
    {
      id: "project.name",
      header: "Project",
      accessorKey: "project.name",
      cell: ({ row }) => {
        return (
          <span className="capitalize">
            {row.original?.project?.name?.replace(/_/g, " ")}
          </span>
        );
      },
    },
    {
      id: "status",
      header: "Status",
      accessorKey: "status",
      cell: StatusCell,
    },
    {
      id: "industry",
      header: "Industry",
      accessorKey: "industry_v1.type",
      cell: ({ row }) => (
        <IndustryTypeText value={row.original?.industry_v1?.type} />
      ),
    },
    {
      id: "industry_v1.name",
      header: "Sub Industry",
      accessorKey: "industry_v1.name",
    },
    {
      id: "nda_level",
      header: "NDA Level",
      accessorKey: "nda_level",
      cell: ({ row }) => {
        return (
          <span className="capitalize">
            {row.original?.nda_level?.replace(/_/g, " ")}
          </span>
        );
      },
    },
    {
      id: "user_created",
      header: "Author",
      accessorKey: "user_created",
      cell: EmployeeCell
    },
    {
      id: "date_created",
      header: "Date Created",
      accessorKey: "date_created",
      cell: DateCell,
    },
    {
      id: "actions",
      header: "",
      accessorKey: "id",
      cell: ({ row }) => {
        const id = row.original.id;
        return (
          <div className="flex items-center justify-end h-full">
            <button
              type="button"
              className="inline-flex cursor-pointer items-center mr-3 justify-center rounded hover:bg-zinc-100 relative action-button transition-opacity"
              onClick={(e) => handleShare(e, id)}
              tabIndex={-1}
            >
              {copiedId === id ? (
                <Check size={16} className="text-green-500" />
              ) : (
                <Copy size={16} />
              )}
            </button>
          </div>
        );
      },
    },
  ];

  const handleCreate = () => {
    setDialogOpen(true);
  };

  return (
    <div>
      <style>{`
        .action-button {
          opacity: 0;
        }
        tr:hover .action-button {
          opacity: 1;
        }
      `}</style>
      <HeaderPortal>
        <PermissionGate collection="case_studies" rule="create:*">
          <CreateItemButton onClick={handleCreate}>Case Study</CreateItemButton>
        </PermissionGate>
      </HeaderPortal>
      <List
        title="Case Studies"
        storageKey="casestudies"
        endPoint="case_studies"
        renderFilters={CaseStudiesFilters}
        columns={columns}
        meta={{ fields }}
        href={(item) => item.id}
      />
      <CreateCaseStudyDialog open={dialogOpen} onOpenChange={setDialogOpen} />
    </div>
  );
}
